export const h = {
  navMenu: ["HOME","REWARDS", "HEROES", "FEATURES"],
}


// WEBPACK FOOTER //
// ./src/i18n/lan/en.js